import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from "antd";
import { InfoWindow } from '../../components/googleMap';
import './MapInfoWindow.css';
import MarketplaceAvailableConsignmentPanel from "../marketplace/MarketplaceAvailableConsignmentPanel";
const MarketplaceConsignmentInfoWindow = ({ consignment, position, marker, visible, onClose, onAssignClicked }) => {
    return (_jsx(InfoWindow, { position: position, marker: marker, visible: visible, onClose: onClose, children: consignment &&
            _jsxs("div", { className: "marketplace-info-window", children: [_jsx(MarketplaceAvailableConsignmentPanel, { consignment: consignment }), _jsx(Button, { htmlType: "button", onClick: onAssignClicked, children: "Assign" }, "assign")] }) }, "MarketplaceConsignmentInfoWindow"));
};
export default MarketplaceConsignmentInfoWindow;
